<template>
  <div class="haiKeSi">
    <input type="" v-model="userName" placeholder="在此输入昵称..." />
    <div class="btns">
      <button @click="createCanvas">生成预览图</button>
      <button @click="downloadCanvas">下载</button>
    </div>
    <div class="img">
      <div>
        <h1>原图</h1>
        <img alt="Vue logo" ref="haiKeSiImg" src="../assets/haiKeSi.png" />
      </div>
      <div>
        <h1>预览图</h1>
        <img
          v-if="isCreat"
          class="result"
          src="../assets/haiKeSi.png"
        />
        <canvas
          v-if="!isCreat"
          ref="haiKeSiCanvas"
          style="border: 1px solid #c3c3c3"
          width="450"
          height="600"
        >
          您的浏览器不支持 HTML5 canvas 标签。
        </canvas>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      userName: "",
      isCreat: false,
      fileName: "",
    };
  },
  created() {
    function judgeFileName(routeName) {
      switch (routeName) {
        case "":
          return "普通款";
        case "Paper":
          return "纸质高清款";
        case "Signature":
          return "照片高糊款";
        case "WithJDG":
          return "JDG联名款";
        case "WithRNG":
          return "RNG联名款";
        case "HaiKeSi":
          return "海克斯限定款";
      }
    }
    this.fileName = judgeFileName(this.$route.name);
  },
  methods: {
    async setData(name,type){
      let data={
        name:name,
        type:type
      }
      const res=await axios.post('https://liiapi.eu.org/smfans/set',data);
      console.log(res);
    },
    downloadCanvas: function () {
      if(this.userName==='') return alert('请先输入昵称,并生成预览图进行确认🙂🙂🙂');
      const saveFile = function (data, fileName) {
        let save_link = document.createElement("a");
        save_link.href = data;
        save_link.download = fileName;

        let event = document.createEvent("MouseEvents");
        event.initEvent("click", true, false);
        save_link.dispatchEvent(event);
      };
      // 内部函数2(可忽略细节)
      const imgType = function (ty) {
        let type = ty.toLowerCase().replace(/jpg/i, "jpeg");
        var r = type.match(/png|jpeg|bmp|gif/)[0];
        return "image/" + r;
      };

      const type = "png"; //设置下载图片的格式
      const cans = this.$refs.haiKeSiCanvas; //canvas实例子
      const img_png_src = cans.toDataURL("image/png"); //将canvas保存为图片
      const imgData = img_png_src.replace(imgType(type), "image/octet-stream");
      const filename = "秀兵证-" + this.fileName + "." + type; //下载图片的文件名

      this.setData(this.userName,this.fileName)
      saveFile(imgData, filename);
    },
    createCanvas() {
      // 创建canvas DOM元素，并设置其宽高和图片一样
      if(this.userName==='') return alert('请先输入昵称🙂🙂🙂');
      let image = this.$refs.haiKeSiImg;
      let canvas = this.$refs.haiKeSiCanvas;
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, image.width, image.height);
      let name = canvas.getContext("2d");
      let len = this.userName.length;
      if(len>7){
        name.font = "36px Arial bolder";
        name.fillText(this.userName, 198-len*15, 135);
      }else{
        name.font = "56px Arial bolder";
        name.fillText(this.userName, 202-len*25, 135);
      }
      return canvas;
    },
  },
};
</script>

<style lang="less" scoped>
.haiKeSi {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
    div {
      margin: 0 50px;
      img {
        width: 450px;
        height: 650px;
      }
      .result {
        position: relative;
        &::after {
          position: absolute;
          content: "xxxxxxxxxx";
          font-size: 20px;
          color: red;
          z-index: 99999;
        }
      }
    }
  }
  input {
    width: 400px;
    height: 40px;
    outline: none;
    font-size: 20px;
    text-indent: 10px;
    margin-top: 20px;
  }
  .btns {
    button {
      cursor: pointer;
      width: 100px;
      height: 40px;
      margin-top: 20px;
      background: none;
      margin: 20px 20px;
      border-radius: 3px;
      font-size: 16px;
      padding: 5px;
    }
  }
}
</style>
